import{isArray as o}from"../../../../../../utils/commonUtils.js";import{DEFAULT_CARD_GROUP_TYPES as t}from"../../constants.js";const s=s=>o(s)&&s.length?s:t;export{s as getCardGroupTypes};
//# sourceMappingURL=getCardGroupTypes.js.map
